import styled from 'styled-components';

const RealizersMissingIcon = styled.span`
  display: inline-block;
  margin-top: 8px;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: #d10404;
`;

export default RealizersMissingIcon;



// WEBPACK FOOTER //
// ./src/components/RealizersMissingIcon/RealizersMissingIcon.js